import { QuestionDetailPage } from './QuestionDetailPage';
export default QuestionDetailPage;
